<div *ngIf="data" [ngClass]="styleConfig?.container || 'report-dialog-container'">
  <mat-tab-group mat-align-tabs="start" style="height: 100%">
    <!-- INFO -->
    <mat-tab [label]="'map.sidebar.object_detail.info' | translate" style="height: 100%">
      <div class="d-flex flex-column">
        <div *ngIf="isFwContract(urn)" class="align-self-end mt-3">
          <button mat-flat-button color="accent" (click)="getContract()">
            <span>Mostra Contratto su CMS2</span>
            <mat-icon>arrow_forward</mat-icon>
          </button>
        </div>

        <div [ngClass]="styleConfig?.wrapperData || 'wrapper-data'">
          <ng-container *ngFor="let item of data">
            <ng-container *ngIf="!isArray(item.value); else arrTemplate">
              <div
                [ngClass]="[styleConfig?.wrapperItem || 'wrapper-item-report-dialog', item.value !== undefined ? styleConfig?.keyValue || 'item-key-value' : '']"
              >
                <div [ngClass]="styleConfig?.key || 'item-key'">
                  {{ item.key.toString() | replace : '_' : ' ' }}
                </div>
                <div [ngClass]="styleConfig?.value || 'item-value'">{{ item.value }}</div>
              </div>
            </ng-container>
            <ng-template #arrTemplate>
              <div [ngClass]="styleConfig?.wrapperItem || 'wrapper-item-report-dialog'" style="flex-basis: 100%">
                <div [ngClass]="styleConfig?.key || 'item-key'">
                  {{ item.key.toString() | replace : '_' : ' ' }}
                </div>

                <ebw-monorepo-report-dialog-object-viewer [data]="item.value">
                </ebw-monorepo-report-dialog-object-viewer>
              </div>
            </ng-template>
          </ng-container>

          <ng-container *appCustomer="[customerEnum.Cogesi]">
            <div
              *ngIf="findPlantKey()"
              [ngClass]="[styleConfig?.wrapperItem || 'wrapper-item', styleConfig?.keyValue || 'item-key-value']"
            >
              <div [ngClass]="styleConfig?.key || 'item-key'">
                {{ 'ePlant' }}
              </div>
              <button
                mat-raised-button
                [matTooltip]="'map.sidebar.object_detail.eplant_tip' | translate"
                color="primary"
                (click)="goToEPlant()"
              >
                <mat-icon>link_2</mat-icon>
                {{ 'map.sidebar.object_detail.eplant' | translate }}
              </button>
            </div>
          </ng-container>

          <!-- JOIN PROPERTIES -->
          <ng-container *ngIf="joinProperties.length">
            <div
              *ngFor="let prop of joinProperties"
              [ngClass]="styleWrapperItem || 'wrapper-item-report-dialog'"
              style="flex-basis: 100%"
            >
              <div [ngClass]="styleKey || 'item-key'">
                {{ prop.key.toString() | replace : '_' : ' ' }}
              </div>
              <div *ngFor="let item of prop.value" class="join-item">
                <div [ngClass]="styleValue || 'item-value'">{{ item.label }}</div>
                <button mat-icon-button (click)="goToDetail(item)">
                  <mat-icon>info_outline</mat-icon>
                </button>
              </div>
              <div *ngIf="prop.value.length === 0" class="join-item">
                <div>Nessun elemento</div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </mat-tab>
    <ng-container *ngIf="showStructure">
      <ng-container *appCustomerCategory="[customerCategoryEnum.Telco]">
        <!-- STRUTTURA ALBERO -->
        <mat-tab #structure [label]="'map.sidebar.object_detail.tree' | translate">
          <div *ngIf="urn && structure.isActive" class="pt-3 px-2">
            <ebw-monorepo-tree
              [urn]="urn"
              [canStartOtdr]="true"
              [notRecursive]="true"
              [expanded]="true"
              (goToOTDR)="goToOtdr($event)"
              (goToDetail)="goToDetail($event)"
              (goToRaccordi)="goToRaccordi($event)"
            ></ebw-monorepo-tree>
          </div>
        </mat-tab>

        <ng-container *appCustomer="[customerEnum.Fastweb]">
          <!-- REPORT PERCORSO SEGMENTO OTTICO -->
          <mat-tab #reportPercorso *ngIf="isFwLink(urn)" [label]="'map.sidebar.object_detail.fw_link_path' | translate">
            <div *ngIf="reportPercorso.isActive" class="pt-3 w-100 d-flex flex-column gap-3">
              <div class="w-100 d-flex justify-content-end">
                <button mat-button [matMenuTriggerFor]="menuPercorso">
                  <mat-icon>download</mat-icon>
                  {{ 'map.map_table.export' | translate }}
                </button>
                <mat-menu #menuPercorso="matMenu">
                  <button mat-menu-item (click)="exportPercorso('pdf')">
                    {{ 'map.map_table.export_pdf' | translate }}
                  </button>
                  <button mat-menu-item (click)="exportPercorso('csv')">
                    {{ 'map.map_table.export_csv' | translate }}
                  </button>
                  <button mat-menu-item (click)="exportPercorso('html')">
                    {{ 'map.map_table.export_html' | translate }}
                  </button>
                </mat-menu>
              </div>
              <ebw-monorepo-tree
                [urn]="urn"
                [type]="'link_devices'"
                [canStartOtdr]="true"
                (goToOTDR)="goToOtdr($event)"
                (goToRaccordi)="goToRaccordi($event)"
                (goToDetail)="goToDetail($event)"
                [expanded]="true"
              ></ebw-monorepo-tree>
            </div>
          </mat-tab>

          <!-- REPORT LUNGHEZZA CAVO -->
          <mat-tab
            #report_lunghezze_cavi
            *ngIf="isFwLink(urn) || isFwCircuit(urn)"
            [label]="'map.sidebar.object_detail.fw_cable_length' | translate"
          >
            <div class="pt-3 w-100 d-flex flex-column gap-3" *ngIf="report_lunghezze_cavi.isActive">
              <div class="w-100 d-flex justify-content-end">
                <button mat-button [matMenuTriggerFor]="menuCavo">
                  <mat-icon>download</mat-icon>
                  {{ 'map.map_table.export' | translate }}
                </button>
                <mat-menu #menuCavo="matMenu">
                  <button mat-menu-item (click)="exportLunghezzeCavo('pdf')">
                    {{ 'map.map_table.export_pdf' | translate }}
                  </button>
                  <button mat-menu-item (click)="exportLunghezzeCavo('csv')">
                    {{ 'map.map_table.export_csv' | translate }}
                  </button>
                  <button mat-menu-item (click)="exportLunghezzeCavo('html')">
                    {{ 'map.map_table.export_html' | translate }}
                  </button>
                </mat-menu>
              </div>
              <ebw-monorepo-tree
                [urn]="urn"
                [type]="'report_lunghezze_cavi'"
                [canStartOtdr]="true"
                (goToOTDR)="goToOtdr($event)"
                (goToDetail)="goToDetail($event)"
                (goToRaccordi)="goToRaccordi($event)"
                [expanded]="true"
              ></ebw-monorepo-tree>
            </div>
          </mat-tab>

          <!-- CAVO SOSTITUTO -->
          <mat-tab #twinCables *ngIf="isSheath(urn)" [label]="'map.sidebar.object_detail.twin_cables' | translate">
            <div class="pt-3 px-2" *ngIf="twinCables.isActive">
              <ebw-monorepo-tree
                [urn]="urn"
                [type]="'twin_cables_report'"
                [notRecursive]="true"
                [singleLevel]="true"
                [expanded]="true"
                [canExport]="false"
                [emptyMessage]="'map.sidebar.object_detail.twin_cables_empty' | translate"
                [errorMessage]="'map.sidebar.object_detail.twin_cables_error' | translate"
                (goToDetail)="goToDetail($event)"
              ></ebw-monorepo-tree>
            </div>
          </mat-tab>

          <!-- CONNECTIVITY -->
          <mat-tab *ngIf="hasConnectivity(urn)" [label]="'map.sidebar.object_detail.fw_connectivity' | translate">
            <ng-template matTabContent>
              <div class="wrapper-item-report-dialog my-3">
                <mat-tab-group>
                  <mat-tab [label]="'map.sidebar.fw_connectivity.fibre_bundle' | translate">
                    <ebw-monorepo-tree
                      [urn]="urn"
                      [type]="'connectivity_fibre_bundle'"
                      [expanded]="true"
                      [canGoToDetail]="false"
                      [canExport]="false"
                      [canExportConnectivity]="true"
                      [canShowOnMap]="false"
                      [notRecursive]="true"
                    ></ebw-monorepo-tree>
                  </mat-tab>
                  <mat-tab *ngIf="isFwBuilding(urn)" [label]="'map.sidebar.fw_connectivity.rme_ports' | translate">
                    <ebw-monorepo-tree
                      [urn]="urn"
                      [type]="'connectivity_rme_ports'"
                      [expanded]="true"
                      [canGoToDetail]="false"
                      [canExport]="false"
                      [canExportConnectivity]="true"
                      [canShowOnMap]="false"
                      [notRecursive]="true"
                    ></ebw-monorepo-tree>
                  </mat-tab>
                  <mat-tab *ngIf="isFwSpliceClosure(urn)" [label]="'map.sidebar.fw_connectivity.devices' | translate">
                    <ebw-monorepo-tree
                      [urn]="urn"
                      [type]="'connectivity_devices'"
                      [expanded]="true"
                      [canGoToDetail]="false"
                      [canExport]="false"
                      [canExportConnectivity]="true"
                      [canShowOnMap]="false"
                      [notRecursive]="true"
                    ></ebw-monorepo-tree>
                  </mat-tab>
                </mat-tab-group>
              </div>
            </ng-template>
          </mat-tab>
        </ng-container>
      </ng-container>
    </ng-container>
  </mat-tab-group>
</div>
